<footer class="text-center py-4">
    <br>
    <h2>
        Thank You For Visiting.
    </h2>
    <h4>
        &copy; Huzaifa Anjum 2024. All rights reserved.
    </h4>
    <br>
</footer>
